var _hash = window.location.hash;
jQuery(document).ready(function ($) { 
  $(document).on("click", ".My-Plan", function (e) {
    e.preventDefault();
    var $this = $(this);
    addWaiting();
    var vals = {
      url: "/wp-admin/admin-ajax.php",
      data: { action: 'fw_my_plan_ajax', which: $this.data("which")},
      dataType: "html",
    };
    $.ajax({
      type: "POST",
      url: vals.url,
      data: vals.data,
      dataType: vals.dataType,
      success: function (data) {
        $('#scholarshipList').addClass('edit-my-plan').html(data);
        addEvent(vals, "my_plan_edit");
        $("#waiting").remove();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details: " + desc + "\nError:" + err);
      },
    });
  });
  $(document).on('click','.save-supervisor,.edit-supervisor,.cancel-supervisor',function(e){
    e.preventDefault();
    var $this = $(this);
    let $form = $this.closest('form');
    addWaiting();
    let action='';
    if($this.hasClass('edit-supervisor')) action='fw_edit_my_plan_ajax';
    else if($this.hasClass('cancel-supervisor')) {
      action='fw_get_my_plan_ajax';
    }
    else if($this.hasClass('save-supervisor')) action='fw_save_my_plan_ajax';
    var vals = {
      url: "/wp-admin/admin-ajax.php",
      data:  $form.serialize()+'&action='+action+'&folder_object_id='+$this.data("folder_object_id")+'&name='+$this.data("name")+'&email='+$this.data("email")+'&type='+$this.data("type"),
      dataType: "html",
    };
    $.ajax({
      type: "POST",
      url: vals.url,
      data: vals.data,
      dataType: vals.dataType,
      success: function (data) {
        if(data.includes('wbl-header')){
          $('#scholarshipList').html(data);
        }else {
          $form.find('.inputs').html(data);
        }
        $('#waiting').remove();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details: " + desc + "\nError:" + err);
      },
    });
  });
  $(document).on('click','.invite-supervisor',function(e){
    e.preventDefault();
    addWaiting();
    let $this=$(this);
    let vals={
      'action':'fw_email_supervisor',
      'Sender':$this.data('sender'),
      'SenderCaseFolderID':$this.data('sender-id'),
      'Recipient':$this.data('recipient'),
      'RecipientName':$this.data('recipient-name'),
      'OpportunityFolderID':$this.data('opportunity'),
    };
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: vals,
      dataType: 'html',
      success: function (data) {
        $('.edit-my-plan').html(data);
        $('#waiting').remove();
      },
      error: function (xhr, desc, err) {
        console.log(xhr);
        console.log("Details: " + desc + "\nError:" + err);
      },
    });
  });
});
function addEvent(data = null, which) {
  if (window.history.pushState) {
    window.history.pushState(data, which, "#" + which);
  } else {
    //location.hash = "#" + which;
  }
}